import { Card } from "@heroui/react";
import { Loader2 } from "lucide-react";

interface TaskLoadingProps {
  message?: string;
}

export function TaskLoading({ message = "Loading..." }: TaskLoadingProps) {
  return (
    <Card className="p-6 bg-[#0C1113] shadow-md border border-gray-800/50 w-full">
      <div className="flex flex-col items-center justify-center space-y-4 py-8">
        <Loader2 className="h-8 w-8 animate-spin text-green-500" />
        <p className="text-sm text-gray-400">{message}</p>
      </div>
    </Card>
  );
}
